// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos Globales para Componentes UI Compartidos */

.page-header {
    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);
    padding: 2rem;
    color: var(--topbar-text);
    box-shadow: var(--shadow-md);
    border-radius: 12px;
    margin-bottom: 2rem;
}

.page-header .header-content {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.page-header .header-icon {
    width: 60px;
    height: 60px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.page-header .header-icon i {
    font-size: 2rem;
    color: var(--topbar-text);
}

.page-header h1 {
    margin: 0;
    font-size: 1.75rem;
    font-weight: 600;
}

.page-header p {
    margin: 0.25rem 0 0 0;
    opacity: 0.9;
    font-size: 0.95rem;
}

/* Dialog Header */
.custom-dialog-header {
    display: flex;
    align-items: center;
    width: 100%;
}

.custom-dialog-header .dialog-title {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.custom-dialog-header .dialog-icon {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    background: var(--theme-primary-soft);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--theme-primary);
}

.custom-dialog-header .dialog-info h3 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 700;
    color: var(--text-primary);
}

.custom-dialog-header .dialog-info p {
    margin: 0.2rem 0 0 0;
    font-size: 0.875rem;
    color: var(--text-secondary);
}

/* Action Toolbar */
.action-toolbar {
    padding: 1.5rem;
    border-bottom: 1px solid var(--border-color);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
}

.action-toolbar .p-input-icon-left>i {
    left: 1rem !important;
}

.action-toolbar .search-input {
    padding-left: 2.75rem !important;
}


.btn-primary-custom {
    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%) !important;
    color: var(--topbar-text) !important;
    border: none !important;
    padding: 0.75rem 1.5rem !important;
    font-weight: 500 !important;
    border-radius: 8px !important;
    box-shadow: var(--shadow-sm) !important;
}

.btn-primary-custom:hover {
    filter: brightness(1.1);
}`, "",{"version":3,"sources":["webpack://./src/components/ui/SharedUI.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD;IACI,4FAA4F;IAC5F,aAAa;IACb,yBAAyB;IACzB,4BAA4B;IAC5B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;AACtB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA,mBAAmB;AACnB;IACI,eAAe;IACf,4CAA4C;IAC5C,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;;AAGA;IACI,uGAAuG;IACvG,oCAAoC;IACpC,uBAAuB;IACvB,kCAAkC;IAClC,2BAA2B;IAC3B,6BAA6B;IAC7B,uCAAuC;AAC3C;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":["/* Estilos Globales para Componentes UI Compartidos */\n\n.page-header {\n    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);\n    padding: 2rem;\n    color: var(--topbar-text);\n    box-shadow: var(--shadow-md);\n    border-radius: 12px;\n    margin-bottom: 2rem;\n}\n\n.page-header .header-content {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.page-header .header-icon {\n    width: 60px;\n    height: 60px;\n    border-radius: 12px;\n    background: rgba(255, 255, 255, 0.15);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.page-header .header-icon i {\n    font-size: 2rem;\n    color: var(--topbar-text);\n}\n\n.page-header h1 {\n    margin: 0;\n    font-size: 1.75rem;\n    font-weight: 600;\n}\n\n.page-header p {\n    margin: 0.25rem 0 0 0;\n    opacity: 0.9;\n    font-size: 0.95rem;\n}\n\n/* Dialog Header */\n.custom-dialog-header {\n    display: flex;\n    align-items: center;\n    width: 100%;\n}\n\n.custom-dialog-header .dialog-title {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.custom-dialog-header .dialog-icon {\n    width: 48px;\n    height: 48px;\n    border-radius: 10px;\n    background: var(--theme-primary-soft);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--theme-primary);\n}\n\n.custom-dialog-header .dialog-info h3 {\n    margin: 0;\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.custom-dialog-header .dialog-info p {\n    margin: 0.2rem 0 0 0;\n    font-size: 0.875rem;\n    color: var(--text-secondary);\n}\n\n/* Action Toolbar */\n.action-toolbar {\n    padding: 1.5rem;\n    border-bottom: 1px solid var(--border-color);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 1rem;\n}\n\n.action-toolbar .p-input-icon-left>i {\n    left: 1rem !important;\n}\n\n.action-toolbar .search-input {\n    padding-left: 2.75rem !important;\n}\n\n\n.btn-primary-custom {\n    background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%) !important;\n    color: var(--topbar-text) !important;\n    border: none !important;\n    padding: 0.75rem 1.5rem !important;\n    font-weight: 500 !important;\n    border-radius: 8px !important;\n    box-shadow: var(--shadow-sm) !important;\n}\n\n.btn-primary-custom:hover {\n    filter: brightness(1.1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
